import {
  parseAsArrayOf,
  parseAsInteger,
  parseAsString,
  parseAsStringLiteral,
  useQueryStates,
} from 'nuqs'
import { ScheduleStatusSchema, DeviationStatusSchema } from '@myapp/contract'
import {
  INITIAL_ARBEITSZEIT_REPORT_FILTERS,
  ArbeitszeitReportFiltersForm,
} from './arbeitszeitReportFilters.types'

export const useArbeitszeitReportFiltersParams = () =>
  useQueryStates(
    {
      dateFrom: parseAsString.withDefault(INITIAL_ARBEITSZEIT_REPORT_FILTERS.dateFrom),
      dateTo: parseAsString.withDefault(INITIAL_ARBEITSZEIT_REPORT_FILTERS.dateTo),
      technicianId: parseAsString.withDefault(INITIAL_ARBEITSZEIT_REPORT_FILTERS.technicianId),
      tradeId: parseAsString.withDefault(INITIAL_ARBEITSZEIT_REPORT_FILTERS.tradeId),
      scheduleStatus: parseAsArrayOf(
        parseAsStringLiteral(ScheduleStatusSchema.options),
      ).withDefault(INITIAL_ARBEITSZEIT_REPORT_FILTERS.scheduleStatus),
      deviationStatus: parseAsArrayOf(
        parseAsStringLiteral(DeviationStatusSchema.options),
      ).withDefault(INITIAL_ARBEITSZEIT_REPORT_FILTERS.deviationStatus),
      pageAuftraege: parseAsInteger.withDefault(1),
      pageAuslastung: parseAsInteger.withDefault(1),
      pageArbeitsorganisation: parseAsInteger.withDefault(1),
    },
    { clearOnDefault: true },
  )

export type ArbeitszeitReportFiltersParams = ReturnType<
  typeof useArbeitszeitReportFiltersParams
>[0]

export const toArbeitszeitReportFiltersForm = (
  params: ArbeitszeitReportFiltersParams,
): ArbeitszeitReportFiltersForm => ({
  dateFrom: params.dateFrom,
  dateTo: params.dateTo,
  technicianId: params.technicianId,
  tradeId: params.tradeId,
  scheduleStatus: params.scheduleStatus,
  deviationStatus: params.deviationStatus,
})
